export default __webpack_public_path__ + "static/media/D8R.303001da.jpg";